import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { CommunicationDetailPaginatorInterface } from '../models/communication-detail-paginator.interface';
import { CustomerFilesInterface } from '../models/customer-files.interface';

@Injectable()
export class FileService {

  constructor(private apiService: ApiService) {}

  /**
   * Create New File
   */
  create(file, label, typeSlug, bucket: string) {
    const formData: FormData = new FormData();
    formData.append('file', file, label === 'selfie' ? 'selfie.png' : file.name);
    formData.append('label', label);
    formData.append('type_slug', typeSlug);
    formData.append('bucket_slug', bucket);
    return this.apiService.postFile<any>('file', formData);
  }

  /**
   * @param page
   * @param items
   */
  getCommunicationDetailFiles(page: number, items: number): Observable<CommunicationDetailPaginatorInterface> {
    return this.apiService.get<CommunicationDetailPaginatorInterface>('communication/detail/files/' + page + '/' + items);
  }

  /**
   * @param details
   */
  files(details: object): Observable<Array<CustomerFilesInterface>> {
    return this.apiService.getFiles('files', details);
  }

  downloadFileById(id: number): Observable<Blob> {
    const data = {
      fileId: id
    };
    return this.apiService.getFile('file/download', data);
  }
}
